import PadViewPage from './padViewPage';

export default PadViewPage;
